import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { SettingsProvider } from './context/SettingsContext';

import Home from './components/pages/Home';
import Signup from './components/pages/Signup';
import Validate from './components/pages/Validate';
import NotFound from './components/NotFound';

const App = () => {
  useEffect(() => {
    document.title = 'Validate Parking with ValParx';
  }, []);

  const settings = {};

  return (
    <SettingsProvider value={settings}>
      <Router>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/signup" element={<Signup />} />
            <Route exact path="/validate/:id" element={<Validate />} />

            {/* Fallback 404 Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
      </Router>
    </SettingsProvider>
  );
}

export default App;
